import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/template/redux/actions';
import * as pluginActions from '../../../features/plugin/redux/actions';
import { EditorState } from 'draft-js';
import TooltipTemplateForm from './TooltipTemplateForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import DocsLink from '../../../common/custom/DocsLink';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { TOOLTIP_TEMPLATE } from 'drapcode-constant';
import * as commonActions from '../../../features/common/redux/actions';

export class TooltipTemplate extends Component {
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetail({projectId,version});
    actions.loadCollections({ projectId, version });
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  handleSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    values.projectId = projectId;
    let args = {
      projectId,
      version,
      values: values,
    };
    this.props.actions.createMailTemplate(args).then(() => {
      this.toggle(TOOLTIP_TEMPLATE);
    });
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/2.0/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  render() {
    const { template, plugin,projectDetail,match,actions } = this.props;
    const { editorState, name, collectionId, selectedCollectionFields } = this.state;
    const { collections, createTooltipTemplatePending } = template;
    const { installedPlugins } = plugin;
    const {projectId,version} =match.params;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={TOOLTIP_TEMPLATE}
              title={'Tooltip Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(TOOLTIP_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    <TooltipTemplateForm
                      handleSubmit={this.handleSubmit}
                      editorState={editorState}
                      name={name}
                      collectionId={collectionId}
                      collections={collections}
                      selectedCollectionFields={selectedCollectionFields}
                      createTooltipTemplatePending={createTooltipTemplatePending}
                      projectDetail={projectDetail}
                      projectId={projectId}
                      version={version}
                      actions={actions}
                    />
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Tooltip Template</b>
                </h5>
                <p>You can create custom tootlip Template.</p>
                <br />
                <DocsLink link="https://academy.drapcode.com/docs/app-event/event-dynamic-email-action/" />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
    projectDetail: state.common.projectDetail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TooltipTemplate);
